import React from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import {
    isAuthenticated,
    migrateLegacyAuth,
    bootstrapAuthFromOpener,
} from '../../utils/auth';
import VideoPlayer from './VideoPlayer';
import './VideoPlayPage.css';

function parsePlayRoute() {
    const m = window.location.pathname.match(/\/play\/video\/([^/]+)/);
    const rawId = m ? m[1] : '';
    const id = Number(rawId);
    const params = new URLSearchParams(window.location.search);
    let title = params.get('title') || '';
    try {
        title = decodeURIComponent(title);
    } catch {
        // keep raw
    }
    return { id, title };
}

function initPlayPageAuth() {
    migrateLegacyAuth();
    bootstrapAuthFromOpener();
    return isAuthenticated();
}

/** 独立播放页，供新标签页打开（/play/video/:id） */
class VideoPlayPage extends React.Component {
    constructor(props) {
        super(props);
        const route = parsePlayRoute();
        this.state = {
            authed: initPlayPageAuth(),
            videoId: route.id,
            title: route.title,
        };
    }

    render() {
        const { authed, videoId, title } = this.state;

        if (!authed) {
            return <Navigate to="/login" replace />;
        }

        if (!videoId || Number.isNaN(videoId)) {
            return (
                <div className="video-play-page video-play-page--error">
                    <p>无效的视频 ID</p>
                    <Button type="primary" onClick={() => window.close()}>
                        关闭窗口
                    </Button>
                </div>
            );
        }

        return (
            <div className="video-play-page">
                <header className="video-play-page__header">
                    <h1 className="video-play-page__title" title={title}>
                        {title || `视频 #${videoId}`}
                    </h1>
                    <Button
                        type="text"
                        icon={<CloseOutlined />}
                        className="video-play-page__close"
                        onClick={() => window.close()}
                    >
                        关闭
                    </Button>
                </header>
                <main className="video-play-page__main">
                    <VideoPlayer videoId={videoId} standalone />
                </main>
            </div>
        );
    }
}

export default VideoPlayPage;
